export default __webpack_public_path__ + "static/media/louis.e30fa3e9.jpeg";